/**
 * AUTO-GENERATED by tools/generate-app-version.mjs — do not edit.
 * Source of truth: root package.json "version".
 */
export const APP_PACKAGE_VERSION = '2.1.8' as const;
